import React, { useContext } from "react";
import FileTreeView from "../../../Components/FileTreeView";
import RepoContext from "../../../context/Repos";
import SplitPane from "react-split-pane";
import CodeEditor from "./CodeEditor";
const SourcePanel = () => {
  const { srcFileTree,setSrcFileTree, InputRepoCreds } = useContext(RepoContext);
  console.log("src tree", srcFileTree, "input repo creds", InputRepoCreds);
  return (
    <SplitPane
      split="vertical"
      minSize={200}
      maxSize={-200}
      defaultSize="30%"
      allowResize={true}
    >
      
      <FileTreeView
        className="fileTree-view"
        fileTree={srcFileTree ? srcFileTree : {}}
        repoName={InputRepoCreds ? InputRepoCreds.repoName : "No repo"}
      />
      
      <CodeEditor type="input"/>
    </SplitPane>
  );
};

export default SourcePanel;
